import { lcpMessage } from '@/utils/lcpMessage';
import { useMessageCenter } from './useMessageCenter';
import { setupMC } from '@/components/utils/messageCenter'

const messageCenter = useMessageCenter();
export function setupMessageCenter() {
    setupModalMessageActions();
    setupMC(messageCenter)
}

function setupModalMessageActions() {
    messageCenter.observe('/modal', 'success').by((message, payload) => {
        lcpMessage.success({
            message,
            showClose: true
        });
    });

    messageCenter.observe('/modal', 'info').by((message, payload) => {
        lcpMessage.info({
            message,
            showClose: true
        });
    });

    messageCenter.observe('/modal', 'error').by((message, payload) => {
        lcpMessage.error({
            message,
            showClose: true
        });
    });

    messageCenter.observe('/modal', 'warning').by((message, payload) => {
        lcpMessage.warning({
            message,
            showClose: true
        });
    });

    messageCenter.observe('/madal/clean', 'info').by((message, payload) => {
        lcpMessage.closeAll();
    });
}
